export const IMAGE_PLACEHOLDER_URL = "/images/placeholder.svg";
export const IMAGE_FAILED_URL = "/images/empty-with-bg.svg";
